/* Skil-Care Bundle Builder — Shopify edition */
(function(){
'use strict';

/* =================================================================
   IMAGES — every photo lives in Shopify Files (Content → Files).
   SBB_CONFIG.filesBase is set by the section (Liquid) to the store's
   Files CDN folder, so each entry below is just a file name.
================================================================= */
const SBB = window.SBB_CONFIG || {};
SBB.root = String(SBB.root || '/').replace(/\/?$/, '/');
const SBB_FILES = {
 "hero": {
  "wheelchair": "sbb-hero-wheelchair.jpg",
  "bed": "sbb-hero-bed.jpg"
 },
 "place": {
  "WC-031": "sbb-place-wc-031.png",
  "WC-032": "sbb-place-wc-032.png",
  "WC-033": "sbb-place-wc-033.png",
  "WC-034": "sbb-place-wc-034.png",
  "WC-035": "sbb-place-wc-035.png",
  "WC-036": "sbb-place-wc-036.png",
  "WC-037": "sbb-place-wc-037.png",
  "WC-055": "sbb-place-wc-055.png",
  "WC-056": "sbb-place-wc-056.png",
  "WC-054": "sbb-place-wc-054.png",
  "WC-045": "sbb-place-wc-045.png",
  "WC-046": "sbb-place-wc-046.png",
  "WC-047": "sbb-place-wc-047.png",
  "WC-048": "sbb-place-wc-048.png",
  "WC-049": "sbb-place-wc-049.png",
  "WC-050": "sbb-place-wc-050.png",
  "WC-051": "sbb-place-wc-051.png",
  "WC-052": "sbb-place-wc-052.png",
  "WC-023": "sbb-place-wc-023.png",
  "WC-021": "sbb-place-wc-021.png",
  "WC-022": "sbb-place-wc-022.png",
  "WC-020": "sbb-place-wc-020.png",
  "WC-030": "sbb-place-wc-030.png",
  "WC-029": "sbb-place-wc-029.png",
  "WC-028": "sbb-place-wc-028.png",
  "WC-027": "sbb-place-wc-027.png",
  "WC-025": "sbb-place-wc-025.png",
  "WC-024": "sbb-place-wc-024.png",
  "WC-019": "sbb-place-wc-019.png",
  "WC-065": "sbb-place-wc-065.png",
  "WC-064": "sbb-place-wc-064.png",
  "WC-063": "sbb-place-wc-063.png",
  "WC-062": "sbb-place-wc-062.png",
  "WC-001": "sbb-place-wc-001.png",
  "WC-002": "sbb-place-wc-002.png",
  "WC-003": "sbb-place-wc-003.png",
  "WC-004": "sbb-place-wc-004.png",
  "WC-005": "sbb-place-wc-005.png",
  "WC-006": "sbb-place-wc-006.png",
  "WC-007": "sbb-place-wc-007.png",
  "WC-008": "sbb-place-wc-008.png",
  "WC-009": "sbb-place-wc-009.png",
  "WC-010": "sbb-place-wc-010.png",
  "WC-011": "sbb-place-wc-011.png",
  "WC-012": "sbb-place-wc-012.png",
  "WC-013": "sbb-place-wc-013.png",
  "WC-014": "sbb-place-wc-014.png",
  "WC-015": "sbb-place-wc-015.png",
  "WC-016": "sbb-place-wc-016.png",
  "WC-017": "sbb-place-wc-017.png",
  "WC-018": "sbb-place-wc-018.png",
  "WC-060": "sbb-place-wc-060.png",
  "WC-061": "sbb-place-wc-061.png",
  "BED-001": "sbb-place-bed-001.png",
  "BED-002": "sbb-place-bed-002.png",
  "BED-040": "sbb-place-bed-040.png",
  "BED-003": "sbb-place-bed-003.png",
  "BED-004": "sbb-place-bed-004.png",
  "BED-018": "sbb-place-bed-018.png",
  "BED-005": "sbb-place-bed-005.png",
  "BED-006": "sbb-place-bed-006.png",
  "BED-007": "sbb-place-bed-007.png",
  "BED-008": "sbb-place-bed-008.png",
  "BED-009": "sbb-place-bed-009.png",
  "BED-010": "sbb-place-bed-010.png",
  "BED-011": "sbb-place-bed-011.png",
  "BED-012": "sbb-place-bed-012.png",
  "BED-020": "sbb-place-bed-020.png",
  "BED-021": "sbb-place-bed-021.png",
  "BED-019": "sbb-place-bed-019.png",
  "BED-016": "sbb-place-bed-016.png",
  "BED-017": "sbb-place-bed-017.png",
  "BED-022": "sbb-place-bed-022.png",
  "BED-023": "sbb-place-bed-023.png",
  "BED-025": "sbb-place-bed-025.png",
  "BED-026": "sbb-place-bed-026.png",
  "BED-042": "sbb-place-bed-042.png",
  "BED-043": "sbb-place-bed-043.png",
  "BED-044": "sbb-place-bed-044.png",
  "BED-045": "sbb-place-bed-045.png",
  "BED-046": "sbb-place-bed-046.png",
  "BED-047": "sbb-place-bed-047.png",
  "BED-048": "sbb-place-bed-048.png",
  "BED-036": "sbb-place-bed-036.png",
  "BED-037": "sbb-place-bed-037.png",
  "BED-013": "sbb-place-bed-013.png",
  "BED-014": "sbb-place-bed-014.png",
  "BED-015": "sbb-place-bed-015.png",
  "BED-038": "sbb-place-bed-038.png",
  "BED-039": "sbb-place-bed-039.png",
  "BED-049": "sbb-place-bed-049.png",
  "BED-050": "sbb-place-bed-050.png",
  "BED-051": "sbb-place-bed-051.png",
  "BED-052": "sbb-place-bed-052.png",
  "BED-053": "sbb-place-bed-053.png",
  "BED-054": "sbb-place-bed-054.png",
  "WC-066": "sbb-place-wc-066.png",
  "WC-067": "sbb-place-wc-067.png",
  "WC-068": "sbb-place-wc-068.png",
  "WC-069": "sbb-place-wc-069.png",
  "WC-070": "sbb-place-wc-070.png",
  "WC-038": "sbb-place-wc-038.png",
  "WC-039": "sbb-place-wc-039.png"
 },
 "thumb": {
  "WC-031": "sbb-thumb-wc-031.png",
  "WC-032": "sbb-thumb-wc-032.png",
  "WC-033": "sbb-thumb-wc-033.png",
  "WC-034": "sbb-thumb-wc-034.png",
  "WC-035": "sbb-thumb-wc-035.png",
  "WC-036": "sbb-thumb-wc-036.png",
  "WC-037": "sbb-thumb-wc-037.png",
  "WC-055": "sbb-thumb-wc-055.png",
  "WC-056": "sbb-thumb-wc-056.png",
  "WC-054": "sbb-thumb-wc-054.png",
  "WC-045": "sbb-thumb-wc-045.png",
  "WC-046": "sbb-thumb-wc-046.png",
  "WC-047": "sbb-thumb-wc-047.png",
  "WC-048": "sbb-thumb-wc-048.png",
  "WC-049": "sbb-thumb-wc-049.png",
  "WC-050": "sbb-thumb-wc-050.png",
  "WC-051": "sbb-thumb-wc-051.png",
  "WC-052": "sbb-thumb-wc-052.png",
  "WC-040": "sbb-thumb-wc-040.png",
  "WC-041": "sbb-thumb-wc-041.png",
  "WC-042": "sbb-thumb-wc-042.png",
  "WC-043": "sbb-thumb-wc-043.png",
  "WC-044": "sbb-thumb-wc-044.png",
  "WC-023": "sbb-thumb-wc-023.png",
  "WC-021": "sbb-thumb-wc-021.png",
  "WC-022": "sbb-thumb-wc-022.png",
  "WC-020": "sbb-thumb-wc-020.png",
  "WC-030": "sbb-thumb-wc-030.png",
  "WC-029": "sbb-thumb-wc-029.png",
  "WC-028": "sbb-thumb-wc-028.png",
  "WC-027": "sbb-thumb-wc-027.png",
  "WC-025": "sbb-thumb-wc-025.png",
  "WC-024": "sbb-thumb-wc-024.png",
  "WC-019": "sbb-thumb-wc-019.png",
  "WC-065": "sbb-thumb-wc-065.png",
  "WC-064": "sbb-thumb-wc-064.png",
  "WC-063": "sbb-thumb-wc-063.png",
  "WC-062": "sbb-thumb-wc-062.png",
  "WC-001": "sbb-thumb-wc-001.png",
  "WC-002": "sbb-thumb-wc-002.png",
  "WC-003": "sbb-thumb-wc-003.png",
  "WC-004": "sbb-thumb-wc-004.png",
  "WC-005": "sbb-thumb-wc-005.png",
  "WC-006": "sbb-thumb-wc-006.png",
  "WC-007": "sbb-thumb-wc-007.png",
  "WC-008": "sbb-thumb-wc-008.png",
  "WC-009": "sbb-thumb-wc-009.png",
  "WC-010": "sbb-thumb-wc-010.png",
  "WC-011": "sbb-thumb-wc-011.png",
  "WC-012": "sbb-thumb-wc-012.png",
  "WC-013": "sbb-thumb-wc-013.png",
  "WC-014": "sbb-thumb-wc-014.png",
  "WC-015": "sbb-thumb-wc-015.png",
  "WC-016": "sbb-thumb-wc-016.png",
  "WC-017": "sbb-thumb-wc-017.png",
  "WC-018": "sbb-thumb-wc-018.png",
  "WC-060": "sbb-thumb-wc-060.png",
  "WC-061": "sbb-thumb-wc-061.png",
  "BED-001": "sbb-thumb-bed-001.png",
  "BED-002": "sbb-thumb-bed-002.png",
  "BED-040": "sbb-thumb-bed-040.png",
  "BED-003": "sbb-thumb-bed-003.png",
  "BED-004": "sbb-thumb-bed-004.png",
  "BED-029": "sbb-thumb-bed-029.png",
  "BED-030": "sbb-thumb-bed-030.png",
  "BED-031": "sbb-thumb-bed-031.png",
  "BED-041": "sbb-thumb-bed-041.png",
  "BED-018": "sbb-thumb-bed-018.png",
  "BED-005": "sbb-thumb-bed-005.png",
  "BED-006": "sbb-thumb-bed-006.png",
  "BED-007": "sbb-thumb-bed-007.png",
  "BED-008": "sbb-thumb-bed-008.png",
  "BED-009": "sbb-thumb-bed-009.png",
  "BED-010": "sbb-thumb-bed-010.png",
  "BED-011": "sbb-thumb-bed-011.png",
  "BED-012": "sbb-thumb-bed-012.png",
  "BED-020": "sbb-thumb-bed-020.png",
  "BED-021": "sbb-thumb-bed-021.png",
  "BED-019": "sbb-thumb-bed-019.png",
  "BED-016": "sbb-thumb-bed-016.png",
  "BED-017": "sbb-thumb-bed-017.png",
  "BED-022": "sbb-thumb-bed-022.png",
  "BED-023": "sbb-thumb-bed-023.png",
  "BED-025": "sbb-thumb-bed-025.png",
  "BED-026": "sbb-thumb-bed-026.png",
  "BED-042": "sbb-thumb-bed-042.png",
  "BED-043": "sbb-thumb-bed-043.png",
  "BED-044": "sbb-thumb-bed-044.png",
  "BED-045": "sbb-thumb-bed-045.png",
  "BED-046": "sbb-thumb-bed-046.png",
  "BED-047": "sbb-thumb-bed-047.png",
  "BED-048": "sbb-thumb-bed-048.png",
  "BED-036": "sbb-thumb-bed-036.png",
  "BED-037": "sbb-thumb-bed-037.png",
  "BED-013": "sbb-thumb-bed-013.png",
  "BED-014": "sbb-thumb-bed-014.png",
  "BED-015": "sbb-thumb-bed-015.png",
  "BED-038": "sbb-thumb-bed-038.png",
  "BED-039": "sbb-thumb-bed-039.png",
  "BED-049": "sbb-thumb-bed-049.png",
  "BED-050": "sbb-thumb-bed-050.png",
  "BED-051": "sbb-thumb-bed-051.png",
  "BED-052": "sbb-thumb-bed-052.png",
  "BED-053": "sbb-thumb-bed-053.png",
  "BED-054": "sbb-thumb-bed-054.png",
  "WC-066": "sbb-thumb-wc-066.png",
  "WC-067": "sbb-thumb-wc-067.png",
  "WC-068": "sbb-thumb-wc-068.png",
  "WC-069": "sbb-thumb-wc-069.png",
  "WC-070": "sbb-thumb-wc-070.png",
  "WC-038": "sbb-thumb-wc-038.png",
  "WC-071": "sbb-thumb-wc-071.png",
  "WC-039": "sbb-thumb-wc-039.png"
 }
};
function sbbFile(name){ return name ? (SBB.filesBase || '') + name : null; }
const HERO_IMG = { wheelchair: sbbFile(SBB_FILES.hero.wheelchair), bed: sbbFile(SBB_FILES.hero.bed) };
const PRODUCT_IMG = {};   for (const k in SBB_FILES.place) PRODUCT_IMG[k] = sbbFile(SBB_FILES.place[k]);
const PRODUCT_THUMB = {}; for (const k in SBB_FILES.thumb) PRODUCT_THUMB[k] = sbbFile(SBB_FILES.thumb[k]);


/* =================================================================
   SHOPIFY PRODUCTS & VARIANTS
   Each builder product is linked to a Shopify product by its handle
   (the last part of the product URL: /products/<handle>). The links
   live in skilcare-bundle-builder-products.js (window.SBB_PRODUCT_LINKS).
   Variants, prices and stock are read LIVE from /products/<handle>.js,
   so whatever variants a product has in Shopify admin appear here
   automatically — nothing about variants is stored in this file.
================================================================= */
const SBB_LINKS = window.SBB_PRODUCT_LINKS || {};
function slugify(name){
  return name.toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/(^-|-$)/g,'');
}
function handleFor(p){ const l = SBB_LINKS[p.id]; return (l && l.handle) || slugify(p.name); }
function qtyFor(p){ const l = SBB_LINKS[p.id]; return (l && +l.qty > 0) ? +l.qty : 1; }
function productUrl(p){ return (SBB.root || '/') + 'products/' + handleFor(p); }

const shopData = {}; // product id -> {status:'loading'|'ok'|'missing', variants:[...], url}
function mockProduct(p){
  // Preview mode only (no Shopify): sample sizes so the picker can be seen working.
  const sized = /^WC-0(0\d|1[0-8])$/.test(p.id);
  const titles = sized ? ['16" x 18"','18" x 16"','20" x 18"'] : ['Default Title'];
  return { variants: titles.map((t,i)=>({ id: 900000 + i, title: t, available: true, price: 4995 + i*500 })) };
}
function loadShopProduct(p){
  if (shopData[p.id]) return shopData[p.id].promise;
  const rec = shopData[p.id] = { status: 'loading' };
  const done = data => { rec.status = 'ok'; rec.variants = data.variants.map(v => ({
      id: v.id, title: v.title, available: v.available !== false, price: v.price, sku: v.sku || '' })); return rec; };
  if (SBB.mock) {
    rec.promise = new Promise(r => setTimeout(() => r(done(mockProduct(p))), 250));
  } else {
    rec.promise = fetch(productUrl(p) + '.js', { headers: { Accept: 'application/json' } })
      .then(r => { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(done)
      .catch(() => { rec.status = 'missing'; return rec; });
  }
  return rec.promise;
}
function variantsFor(p){ const r = shopData[p.id]; return (r && r.status === 'ok') ? r.variants : null; }
function chosenVariant(p){
  const vs = variantsFor(p); if (!vs || !vs.length) return null;
  let v = vs.find(x => String(x.id) === String(selectedVariant[p.id]));
  if (!v) { v = vs.find(x => x.available) || vs[0]; selectedVariant[p.id] = v.id; }
  return v;
}
function formatMoney(cents){
  try { return new Intl.NumberFormat(SBB.locale || 'en-US', { style: 'currency', currency: SBB.currency || 'USD' }).format(cents / 100); }
  catch (e) { return '$' + (cents / 100).toFixed(2); }
}
function escHtml(s){ return String(s).replace(/[&<>"]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c])); }

/* =================================================================
   ZONES — numbered/colored to match your reference mockups exactly
================================================================= */
const ZONE_COLORS = ['#6C3EA8','#1A5FAA','#2E9E5B','#E8762B','#8E44AD','#D4A017','#B5384D','#0FA3A0','#D6417A','#1A9CCB','#0D2B5E','#5B8DEF'];

/* Fixed visual stacking order (back-to-front) so placed product photos
   always layer the same way regardless of the order the person clicked
   them in. Physical logic: things mounted to the chair frame (rear rack,
   headrest, backrest) sit behind; seat/tray/belt sit in front of the
   backrest's lower edge; leg/foot supports are frontmost. Zones not
   listed fall back to the order they were placed (shouldn't happen once
   every zone has an entry here). */
const ZONE_STACK_ORDER = {
  wheelchair: ['rear','back','head','arm_l','arm_r','seat','position','tray_lap','waist','leg_l','leg_r','feet'],
  bed: ['floor','rail_l','rail_r','leg_l','hip','mid','upper','arm','head','monitor']
};
function stackIndex(equip, key){
  const order = ZONE_STACK_ORDER[equip] || [];
  const i = order.indexOf(key);
  return i === -1 ? order.length : i; // unknown zones stay behind known ones
}

/* Zones that can hold several products at once, one per product category.
   Bed zone 6 can take a transfer sheet, the sensor pad and a positioning
   piece together; a second product from the SAME category still swaps. */
const MULTI_SLOT_ZONES = { wheelchair: ['rear'], bed: ['mid'] }; // rear: a storage item and the fall monitor can both attach
function baseKey(k){ return String(k).split('|')[0]; }
function slotKeyFor(equip, zoneKey, product){
  return (MULTI_SLOT_ZONES[equip] || []).includes(zoneKey) ? `${zoneKey}|${product.cat}` : zoneKey;
}
/* Flat items that lie directly on the mattress are always drawn first,
   so anything else placed on the bed sits on top of them. */
const UNDERLAY_LAYER = { 'BED-013':-2, 'BED-014':-2, 'BED-015':-2, 'BED-036':-1, // sheets lowest, sensor pad just above
  'WC-066':5.5, 'WC-067':5.5, 'WC-068':5.5, 'WC-069':5.5, 'WC-070':5.5 }; // chair sensor pad / alarm belt: on the seat cushion, under the tray and positioning pieces
function layerIndex(equip, key, id){ return (id in UNDERLAY_LAYER) ? UNDERLAY_LAYER[id] : stackIndex(equip, baseKey(key)); }

const ZONES = {
  wheelchair: [
    {n:1, key:'head',  label:'Head / Neck',              x:58, y:8},
    {n:2, key:'back',  label:'Back / Posture',           x:55, y:22},
    {n:3, key:'arm_l', label:'Left Arm Support',  group:'arm', side:'Left', x:38, y:28},
    {n:4, key:'arm_r', label:'Right Arm Support', group:'arm', side:'Right', x:70, y:29},
    {n:5, key:'tray_lap', label:'Tray / Lap',             x:42, y:36},
    {n:6, key:'seat',  label:'Seat Cushion',              x:50, y:53},
    {n:7, key:'position', label:'Positioning',            x:40, y:52},
    {n:8, key:'waist', label:'Safety',                    x:55, y:45},
    {n:9, key:'leg_l', label:'Left Leg Support', group:'leg', side:'Left', x:33, y:62},
    {n:10,key:'leg_r', label:'Right Leg Support', group:'leg', side:'Right', x:52, y:64},
    {n:11,key:'feet',  label:'Foot Support',              x:39, y:80},
    {n:12,key:'rear',  label:'Storage & Accessories',     x:74, y:22},
  ],
  bed: [
    {n:1, key:'head',    label:'Head / Pillow',            x:63, y:16},
    {n:2, key:'upper',   label:'Upper Body / Torso',       x:58, y:29},
    {n:3, key:'rail_l',  label:'Left Bed Rail', group:'rail', side:'Left', x:46, y:24},
    {n:4, key:'rail_r',  label:'Right Bed Rail', group:'rail', side:'Right', x:80, y:36},
    {n:5, key:'arm',     label:'Arm Support (Left/Right)', x:64, y:45},
    {n:6, key:'mid',     label:'Mid-Body / Positioning',   x:51, y:45},
    {n:7, key:'hip',     label:'Hip / Coccyx',             x:49, y:53},
    {n:8, key:'leg_l',   label:'Left Leg / Knee', x:34, y:60},
    {n:9, key:'floor',   label:'Floor / Fall Mat Area',    x:84, y:75},
    {n:10,key:'monitor', label:'Fall Monitor / Alarm',     x:86, y:24},
  ]
};

/* =================================================================
   PRODUCTS — [id, name, zone(or group), side, phase, category]
================================================================= */
/* Short one-line differentiator shown under each product name in the drawer.
   Edit freely; a product with no entry simply shows no description. */
const SBB_DESC = {
  "WC-001": "Extra-soft gel for comfort and pressure relief on any seat",
  "WC-002": "Budget-friendly low-profile gel cushion for any seating surface",
  "WC-003": "Gel over foam with coccyx cutout for tailbone skin breakdown",
  "WC-004": "Lightweight air cushion, economical, works indoors or outdoors",
  "WC-005": "Long-sitting comfort and healing therapy, including stage IV ulcers",
  "WC-006": "Stops sliding out of the chair while preventing pressure sores",
  "WC-007": "Top-level pressure relief with wedged base that levels the seat",
  "WC-008": "Entry-level gel-foam cushion for everyday comfort and pressure relief",
  "WC-009": "Soft air on top with a stable foam base underneath",
  "WC-010": "Pronounced contours control sliding and improve sitting posture",
  "WC-011": "Gel-foam cushion with X-pattern gel for pressure redistribution",
  "WC-012": "Four gel-filled pods add stability with pressure relief",
  "WC-013": "Cube-cut foam relieves pressure and minimizes skin shear",
  "WC-014": "Four gel pods for stability plus raised front against sliding",
  "WC-015": "Adjustable 25-cell air cushion spreads weight and boosts circulation",
  "WC-016": "Standard gel-foam comfort with a colorful stars and sparkles design",
  "WC-017": "Low-rise visco memory foam molds to body and aids posture",
  "WC-018": "Rigid foam base that eliminates a sagging, hammocked wheelchair seat",
  "WC-060": "Pre-inflated air back cushion for added comfort in any chair",
  "WC-061": "Portable foam pad that cushions the back of 16–18\" wheelchairs",
  "WC-062": "Economically converts a standard wheelchair to a reclining back",
  "WC-063": "Adjustable side supports for maximum control of side leaning",
  "WC-064": "Removable rigid orthosis for superior lateral control in wheelchairs",
  "WC-065": "Solid back with optional gel packs for lumbar or lateral support",
  "WC-019": "Lumbar support that adjusts in thickness to personal preference",
  "WC-024": "Dual-sided support fills chair gaps to promote proper sitting posture",
  "WC-025": "Side wings that control excessive side-to-side movement in wheelchairs",
  "WC-026": "Fits any wheelchair or geri-chair for comfortable lateral positioning",
  "WC-027": "Simple back support that promotes correct upright sitting posture",
  "WC-028": "Cooling gel head support that adjusts in width to fit",
  "WC-029": "Basic headrest that fits any chair with an extended back",
  "WC-030": "Triangular head positioner for chairs with extended backs",
  "WC-020": "Foam-covered plastic insert supports residents who lean to one side",
  "WC-021": "Solid foam arm trough mounts on armrests to support upper trunk",
  "WC-022": "Cylindrical foam bolsters on armrests reduce unwanted side leaning",
  "WC-023": "Easy-on foam arm trough that stabilizes the torso against leaning",
  "WC-031": "Adds comfortable foam padding to hard, open-arm wheelchair armrests",
  "WC-032": "Armrest pad with attached pouch for phone, glasses and papers",
  "WC-033": "Rotating arm support that mounts to most standard wheelchairs",
  "WC-034": "Non-restrictive lap cushion that helps body position and balance",
  "WC-035": "Mounted flat tray for meals and activities, flips away to exit",
  "WC-036": "Economical tray with easy-release belts for eating or working",
  "WC-037": "Soft lap-top cushion for comfortable support across the lap",
  "WC-038": "Easily removable, non-restrictive lap cushion for wheelchair positioning",
  "WC-039": "Gel-top tray with tactile and visual stimulation to calm agitation",
  "WC-045": "Prevents foot drop and contractures while positioning legs on chair",
  "WC-046": "Universal foot support that swings away for easy chair exit",
  "WC-047": "Two separate footrest extenders for individual foot and leg support",
  "WC-048": "Controls foot drop, keeps legs in place, removable leg divider",
  "WC-049": "Simple one-piece extender for foot support and leg cushioning",
  "WC-050": "Economical pad that stops legs slipping behind the footrest",
  "WC-051": "Covers cushion the hard metal surfaces of wheelchair leg rests",
  "WC-052": "Guards legs against skin tears from sharp footrest hanger edges",
  "WC-055": "Non-restrictive belt resident can release; aids posture and safety",
  "WC-054": "Shaped foam wedge keeps legs apart and controls contraction",
  "WC-056": "Seat belt with buckle alarm alerts caregivers before chair exit",
  "WC-066": "Pressure pad alerts caregivers when resident tries to leave chair",
  "WC-067": "Antimicrobial alarm belt with adjustable loops alerts before chair exit",
  "WC-068": "Easy-release belt with magnetic alarm alerts caregivers before exit",
  "WC-069": "Gel-foam pressure relief cushion with a built-in exit sensor",
  "WC-070": "Firm leveling pad with built-in sensor, fits under 16–18\" cushions",
  "WC-071": "Alarm monitor that connects sensors and alerts caregivers to falls",
  "WC-040": "Universal carry bag for papers, glasses, pens and personal items",
  "WC-041": "Flat wheelchair bag for carrying papers, charts and folders",
  "WC-042": "Multi-pocket bag for personal items on wheelchair or walker",
  "WC-043": "Oversized carry sack that attaches to any chair, bed or walker",
  "WC-044": "Keeps removed wheelchair footrests together so they never get lost",
  "BED-001": "Super-soft foam pillow for head, knees, ankles or anywhere",
  "BED-002": "Wipe-clean vinyl pillow that keeps bacteria at bay between patients",
  "BED-040": "Multi-viscosity pillow off-loads heels when a boot isn't tolerated",
  "BED-003": "Bed wedge elevates the upper body and promotes hip-spine alignment",
  "BED-004": "Upper-body elevation wedge for acid reflux and GERD relief",
  "BED-005": "Single wedge contoured to the optimum 30° side-lying angle",
  "BED-006": "Pair of 45° wedges for steeper side-lying positioning",
  "BED-007": "Four-bolster full-body system for stable side-lying coccyx off-loading",
  "BED-008": "30° wedges plus slider sheet: coccyx relief and safer transfers",
  "BED-009": "30° bolster system with an interchangeable transfer slide sheet",
  "BED-010": "Two attached 30° bolsters with detachable absorbent pad",
  "BED-011": "Nurse turning system that floats the tailbone and reduces strain",
  "BED-012": "Absorbent transfer pad with two vinyl foam wedges for repositioning",
  "BED-018": "Soft trough rests and elevates the arm in a stable position",
  "BED-020": "Versatile foam bolster for under neck, knees, arms or sides",
  "BED-021": "Creates a raised mattress edge to help prevent rolling out",
  "BED-019": "Keeps legs apart in bed to prevent contracture and abduction",
  "BED-016": "Vinyl-covered foam bolster that elevates and supports the knees",
  "BED-017": "Soft cloth-covered foam elevator for under ankles or thighs",
  "BED-022": "Keeps feet comfortably positioned at the end of the bed",
  "BED-023": "Affordable super-soft boot to treat and prevent heel pressure sores",
  "BED-025": "Zero-pressure boot with adjustable back for multiple foot angles",
  "BED-026": "Upgraded Heel-Float with cutouts, extended foot support and cooling",
  "BED-042": "The original soft foam heel off-loading boot with cooling gel",
  "BED-043": "Walker boot with adjustable launderable back and detachable foot tread",
  "BED-044": "Off-loads heels in bed and doubles as a walking boot",
  "BED-045": "Zero-pressure heel boot with wipe-clean stretch cover for easy cleaning",
  "BED-046": "Elevates legs to off-load heels when boots aren't tolerated",
  "BED-047": "Basic foam heel protector for preventing pressure ulcers",
  "BED-048": "Three-function positioner that suspends heels off the bed",
  "BED-036": "Pressure pad alerts caregivers the moment a resident leaves bed",
  "BED-037": "Alarm monitor that connects sensors and alerts caregivers to falls",
  "BED-013": "Absorbent pad wicks moisture and helps with positioning and transfers",
  "BED-014": "Turning sheets that reduce staff injury and support turning protocols",
  "BED-015": "Low-friction slider sheet with handles and soft cloth top",
  "BED-029": "Classic extended-height vinyl pads prevent bruising and rail entrapment",
  "BED-030": "Vinyl pads sized for split rails; prevent bruising and entrapment",
  "BED-031": "16\"-high wedge pad for maximum cushioning against the rail",
  "BED-041": "Rail pad with clear window for visibility and less isolation",
  "BED-038": "Impact mat with thin floor-hugging edge, beside bed or chair",
  "BED-039": "Easy-care one-piece elastomeric foam with low beveled edges",
  "BED-049": "High-impact foam with tapered edges for easy wheelchair roll-on",
  "BED-050": "Shock-absorbing bonded foam mat with heat-sealed vinyl cover",
  "BED-051": "2\" fall mat with built-in alarm when pressure is applied",
  "BED-052": "Thin 1\" alarm floor pad alerts caregivers; not impact-absorbing",
  "BED-053": "High-density polyurethane foam mat with heat-sealed vinyl cover",
  "BED-054": "Folding closed-cell foam mat designed for lower-height beds"
};

const RAW = {
wheelchair: [
['WC-001','Super Soft Econo-Gel Cushion','seat','Center',1,'Seat Cushions'],
['WC-002','Econo-Gel Cushion','seat','Center',1,'Seat Cushions'],
['WC-003','Gel-Foam Cushion (classic)','seat','Center',1,'Seat Cushions'],
['WC-004','Air Lift Seat Cushion','seat','Center',1,'Seat Cushions'],
['WC-005','Air Lock Cushion','seat','Center',1,'Seat Cushions'],
['WC-006','Anti-Thrust Cushion','seat','Center',1,'Seat Cushions'],
['WC-007','Ultra-Cushion Wedged','seat','Center',1,'Seat Cushions'],
['WC-008','Basic Gel Foam Cushion','seat','Center',1,'Seat Cushions'],
['WC-009','Foam Air Cushion','seat','Center',1,'Seat Cushions'],
['WC-010','Contour Cushion','seat','Center',1,'Seat Cushions'],
['WC-011','X-Gel Cushion','seat','Center',1,'Seat Cushions'],
['WC-012','Position Plus Cushion','seat','Center',1,'Seat Cushions'],
['WC-013','Pressure Check Cushion','seat','Center',1,'Seat Cushions'],
['WC-014','Stability Plus Cushion','seat','Center',1,'Seat Cushions'],
['WC-015','Inflatable Square Cushion','seat','Center',1,'Seat Cushions'],
['WC-016','Starry Night Cushion','seat','Center',1,'Seat Cushions'],
['WC-017','Visco Conform Cushion','seat','Center',1,'Seat Cushions'],
['WC-018','Wheelchair Leveling Pad','seat','Center',1,'Seat Cushions'],
['WC-060','Air Lift Backrest Cushion','back','Center',1,'Back Supports'],
['WC-061','Wheelchair Backrest Pad','back','Center',1,'Back Supports'],
['WC-062','Reclining Wheelchair Backrest','back','Center',1,'Back Supports'],
['WC-063','Adjustable Lateral Support','back','Both',1,'Back Supports'],
['WC-064','Lateral Support Orthosis','back','Left/Right/Both',1,'Back Supports'],
['WC-065','Lateral/Lumbar Support','back','Center',1,'Back Supports'],
['WC-019','Modular Lumbar Support','back','Center',1,'Back Supports'],
['WC-024','Snug Support','back','Left/Right/Both',1,'Back Supports'],
['WC-025','Wheelchair Side Wings','back','Both',1,'Back Supports'],
['WC-026','Universal Chair Side Wings','back','Both',2,'Back Supports'],
['WC-027','Wheelchair Posture Support','back','Center',1,'Back Supports'],
['WC-028','Adjustable Head Positioner w/Gel','head','Center',1,'Head Supports'],
['WC-029','Standard Headrest','head','Center',1,'Head Supports'],
['WC-030','Triangular Head Positioner','head','Center',1,'Head Supports'],
['WC-020','Lateral Body Support','arm','Left/Right',1,'Arm Supports'],
['WC-021','Lateral Stabilizer Arm Trough','arm','Left/Right',1,'Arm Supports'],
['WC-022','Lateral Stabilizer Armrest Bolster','arm','Left/Right/Both',1,'Arm Supports'],
['WC-023','EZ On Lateral Support','arm','Left/Right',1,'Arm Supports'],
['WC-031','Foam Padded Armrest','arm','Left/Right/Both',1,'Arm Supports'],
['WC-032','Armrest Cushion w/Storage Pouch','arm','Left/Right',1,'Arm Supports'],
['WC-033','Mobile Arm Support','arm','Left/Right',2,'Arm Supports'],
['WC-034','Lift-Away Wheelchair Tray','tray_lap','Center',1,'Trays & Lap'],
['WC-035','Wheelchair Flip Tray','tray_lap','Center',1,'Trays & Lap'],
['WC-036','Wheelchair Econo Tray','tray_lap','Center',1,'Trays & Lap'],
['WC-037','Lap Top Cushion','tray_lap','Center',1,'Trays & Lap'],
['WC-038','Lift-Off Lap Cushion','tray_lap','Center',1,'Trays & Lap'],
['WC-039','Gel-Top Sensory Tray','tray_lap','Center',2,'Trays & Lap'],
['WC-045','Foot Cradle','feet','Both',1,'Leg & Foot Supports'],
['WC-046','Swing-Away Foot Support','feet','Left/Right/Both',1,'Leg & Foot Supports'],
['WC-047','Two-Piece Footrest Extender','feet','Both',1,'Leg & Foot Supports'],
['WC-048','Footrest Extender w/Leg Separation','feet','Both',1,'Leg & Foot Supports'],
['WC-049','One-Piece Econo-Footrest Extender','feet','Both',1,'Leg & Foot Supports'],
['WC-050','Wheelchair Leg Pad','leg','Both',1,'Leg & Foot Supports'],
['WC-051','Calf Pad Cover','leg','Left/Right/Both',1,'Leg & Foot Supports'],
['WC-052','Leg Bolster','leg','Left/Right/Both',1,'Leg & Foot Supports'],
['WC-055','Resident Release Nylon Belt','position','Center',1,'Positioning'],
['WC-056','Seat Belt w/Buckle Sensor','waist','Center',1,'Safety'],
['WC-066','Chair Sensor Pad','waist','Center',1,'Safety'],
['WC-067','BioShield Alarm Belt','waist','Center',1,'Safety'],
['WC-068','EZ Release Sensor Belt','waist','Center',1,'Safety'],
['WC-069','Gel-Foam Cushion w/Alarm Sensor','waist','Center',1,'Safety'],
['WC-070','Leveling Pad and Sensor','waist','Center',1,'Safety'],
['WC-071','SignalSafe Fall Monitor','rear','Center',1,'Safety'],
['WC-054','Abduction Wedge','position','Center',2,'Positioning'],
['WC-040','ChairPack','rear','Center',1,'Storage & Accessories'],
['WC-041','Chart Holder','rear','Center',1,'Storage & Accessories'],
['WC-042','Wheelchair/Walker Handy Bag','rear','Center',1,'Storage & Accessories'],
['WC-043','Just-A-Sack','rear','Center',1,'Storage & Accessories'],
['WC-044','Footrest Bag for Wheelchair','rear','Center',1,'Storage & Accessories'],
],
bed: [
['BED-001','Super Soft Head Pillow','head','Center',1,'Pillows & Wedges'],
['BED-002','SmartLine Therapy Pillow','head','Center',2,'Pillows & Wedges'],
['BED-040','Infinity Pillow','head','Center',1,'Pillows & Wedges'],
['BED-003','Elevating Bed Wedge','upper','Center',1,'Pillows & Wedges'],
['BED-004','Anti-Reflux Wedge','upper','Center',1,'Pillows & Wedges'],
['BED-005','30-Degree Positioning Wedge','mid','Left/Right',1,'Positioning Systems'],
['BED-006','45° Positioning Wedge','mid','Left/Right',1,'Positioning Systems'],
['BED-007','30° Full Body Bed Support System','mid','Center',1,'Positioning Systems'],
['BED-008','30º Bed System w/Slider Sheet & Two Wedges','mid','Center',1,'Positioning Systems'],
['BED-009','30˚ Bed Bolster System with Slide Sheet','mid','Center',1,'Positioning Systems'],
['BED-010','Bed Support System w/Attached 30° Bolster','mid','Left/Right',1,'Positioning Systems'],
['BED-011','Skil-Care Turn & Positioning System','mid','Center',1,'Positioning Systems'],
['BED-012','In-Bed Resident Positioning System','mid','Center',1,'Positioning Systems'],
['BED-018','Elevating Arm Support','arm','Left/Right/Both',1,'Arm Supports'],
['BED-020','Foam Bolster','mid','Left/Right',2,'Body Positioning'],
['BED-021','Roll Control Bolster','mid','Left/Right',1,'Body Positioning'],
['BED-019','Abductor/Contracture Cushion','hip','Center',1,'Hip / Coccyx Support'],
['BED-016','Knee Elevator','mid','Center',1,'Leg & Knee Supports'],
['BED-017','Foam Leg/Thigh Elevator','mid','Left/Right/Both',1,'Leg & Knee Supports'],
['BED-022','Bed-Foot Support','leg_l','Center',1,'Leg & Knee Supports'],
['BED-023','Super Soft HeelCheck Boot','hip','Center',1,'Heel Protection'],
['BED-025','Adjustable Heel-Float','hip','Center',2,'Heel Protection'],
['BED-026','Heel-Float Plus','hip','Center',2,'Heel Protection'],
['BED-042','Heel-Float','hip','Center',1,'Heel Protection'],
['BED-043','Adjustable Heel-Float Walker Boot','hip','Center',1,'Heel Protection'],
['BED-044','Heel-Float Walker Boot','hip','Center',1,'Heel Protection'],
['BED-045','Heel-Float Wipe-Clean','hip','Center',1,'Heel Protection'],
['BED-046','Heels-Off','hip','Center',1,'Heel Protection'],
['BED-047','Foam Pressure Relieving Heel Protector','hip','Center',1,'Heel Protection'],
['BED-048','Tri-Functioning Heels-Off Loader','hip','Center',1,'Heel Protection'],
['BED-036','Bed Sensor Pad','mid','Center',1,'Fall Prevention'],
['BED-037','SignalSafe Fall Monitor','monitor','Center',1,'Fall Prevention'],
['BED-013','TLC Positioning Pad','mid','Center',1,'Transfer & Repositioning'],
['BED-014','Transfer and Reposition Sheets','mid','Center',1,'Transfer & Repositioning'],
['BED-015','Cozy Cloth & Nylon Slider Sheet w/Handles','mid','Center',2,'Transfer & Repositioning'],
['BED-029','Seizure Pads/Bed Rail Pad Classic Vinyl','rail','Left/Right/Both',1,'Seizure Pads/Bed Rail Pads'],
['BED-030','Seizure Pads/Split-Rail Vinyl Bed Rail Pads','rail','Left/Right/Both',1,'Seizure Pads/Bed Rail Pads'],
['BED-031','Seizure Pads/Bed Rail Wedge and Pad','rail','Left/Right/Both',1,'Seizure Pads/Bed Rail Pads'],
['BED-041','Seizure Pads/Thru-View Vinyl Bed Rail Pads','rail','Left/Right/Both',1,'Seizure Pads/Bed Rail Pads'],
['BED-038','Safe & Sound Fall Mat','floor','Center',1,'Fall Mats'],
['BED-039','EZ Landing II Fall Mat','floor','Center',2,'Fall Mats'],
['BED-049','Roll-On Bedside Fall Mat','floor','Center',1,'Fall Mats'],
['BED-050','Safeside Fall Mat','floor','Center',1,'Fall Mats'],
['BED-051','SignalSafe Bedside Fall Mat System','floor','Center',1,'Fall Mats'],
['BED-052','SignalSafe Floor Pad System','floor','Center',1,'Fall Mats'],
['BED-053','Soft-Fall Bedside Mat','floor','Center',1,'Fall Mats'],
['BED-054','Tri-Fold Bedside Mat','floor','Center',1,'Fall Mats'],
]
};

const CAT_ICON = {
  'Seat Cushions':'💺','Back Supports':'🪑','Head Supports':'🧠','Arm Supports':'💪',
  'Trays & Lap':'🍽','Leg & Foot Supports':'🦶','Positioning':'🔺','Safety':'🔒','Storage & Accessories':'🎒',
  'Pillows & Wedges':'🛌','Positioning Systems':'📐','Seizure Pads/Bed Rail Pads':'🛡','Body Positioning':'🔄',
  'Hip / Coccyx Support':'🩹','Leg & Knee Supports':'🦵','Heel Protection':'👣','Fall Prevention':'🚨',
  'Transfer & Repositioning':'🔃','Fall Mats':'▭'
};

const CAT_ORDER = {
  wheelchair: ['Head Supports','Back Supports','Arm Supports','Trays & Lap','Seat Cushions','Positioning','Safety','Leg & Foot Supports','Storage & Accessories'],
  bed: ['Pillows & Wedges','Seizure Pads/Bed Rail Pads','Arm Supports','Positioning Systems','Body Positioning','Hip / Coccyx Support','Leg & Knee Supports','Heel Protection','Fall Prevention','Transfer & Repositioning','Fall Mats']
};

function buildProducts(){
  const out = {};
  for(const eq of ['wheelchair','bed']){
    out[eq] = RAW[eq].map(r=>({id:r[0],name:r[1],zone:r[2],side:r[3],phase:r[4],cat:r[5],img:PRODUCT_IMG[r[0]]||null,thumb:PRODUCT_THUMB[r[0]]||PRODUCT_IMG[r[0]]||null}));
  }
  return out;
}
const PRODUCTS = buildProducts();

/* ---------------------------------------------------------------- */
let currentEquip = 'wheelchair';
let placed = {wheelchair:{}, bed:{}};
let openCats = new Set();
let selectedVariant = {}; // product id -> chosen variant string

const TITLES = {
  wheelchair: {title:'Build Your Wheelchair Solution', sub:'Click a category on the right, then drag a product onto its highlighted zone on the wheelchair.'},
  bed: {title:'Build Your Bed Solution', sub:'Click a category on the right, then drag a product onto its highlighted zone on the bed.'}
};

function zoneColor(n){ return ZONE_COLORS[(n-1) % ZONE_COLORS.length]; }

function catZoneNumbers(equip, cat){
  const keys = new Set();
  PRODUCTS[equip].filter(p=>p.cat===cat).forEach(p=>keys.add(p.zone));
  const nums = new Set();
  ZONES[equip].forEach(z=>{
    if(keys.has(z.key) || (z.group && keys.has(z.group))) nums.add(z.n);
  });
  return [...nums].sort((a,b)=>a-b);
}

function productZoneNumbers(equip, p){
  const nums = new Set();
  ZONES[equip].forEach(z=>{
    if(z.key===p.zone || (z.group && z.group===p.zone)) nums.add(z.n);
  });
  return [...nums].sort((a,b)=>a-b);
}

function categoryForZoneKey(equip, zoneKey){
  const zoneDef = ZONES[equip].find(z=>z.key===zoneKey);
  if(!zoneDef) return null;
  const prod = PRODUCTS[equip].find(p => p.zone===zoneKey || (zoneDef.group && p.zone===zoneDef.group));
  return prod ? prod.cat : null;
}

function openCategoryByName(cat){
  if(!cat) return;
  const catDiv = [...document.querySelectorAll('.cat')].find(el => el.querySelector('.label') && el.querySelector('.label').textContent === cat);
  if(!catDiv) return;
  catDiv.classList.toggle('open');
  if(catDiv.classList.contains('open')) openCats.add(cat); else openCats.delete(cat);
  catDiv.scrollIntoView({behavior:'smooth', block:'nearest'});
}

function renderLegend(){
  const list = document.getElementById('sbb-legendList');
  list.innerHTML = '';
  ZONES[currentEquip].forEach(z=>{
    const row = document.createElement('div');
    row.className = 'legend-row';
    row.id = 'sbb-legend-'+z.key;
    row.innerHTML = `<div class="legend-dot" style="background:${zoneColor(z.n)}">${z.n}</div><div class="zn">${z.label}</div><div class="check">✓</div>`;
    row.addEventListener('click', ()=> openCategoryByName(categoryForZoneKey(currentEquip, z.key)) );
    list.appendChild(row);
  });
}

function renderDrawer(){
  const catList = document.getElementById('sbb-catList');
  catList.innerHTML = '';
  const grouped = {};
  PRODUCTS[currentEquip].forEach(p=>{ (grouped[p.cat] = grouped[p.cat] || []).push(p); });

  CAT_ORDER[currentEquip].forEach(cat=>{
    const items = grouped[cat] || [];
    const div = document.createElement('div');
    const isOpen = openCats.has(cat);
    div.className = 'cat' + (isOpen ? ' open' : '');

    const readyCount = items.length;
    const head = document.createElement('div');
    head.className = 'cat-head';
    const nums = catZoneNumbers(currentEquip, cat);
    const numsHtml = nums.map(n=>`<div class="cat-num" style="background:${zoneColor(n)}">${n}</div>`).join('');
    head.innerHTML = `<div class="cat-nums">${numsHtml}</div><div class="label">${cat}</div><div class="count">${readyCount}</div><div class="arrow">▸</div>`;
    head.addEventListener('click', ()=>{
      div.classList.toggle('open');
      if(div.classList.contains('open')) openCats.add(cat); else openCats.delete(cat);
    });

    const body = document.createElement('div');
    body.className = 'cat-body';
    const inner = document.createElement('div');
    inner.className = 'cat-body-inner';

    if(items.length===0){
      inner.innerHTML = `<div style="font-size:11.5px;color:var(--ink-soft);padding:4px 2px;">No SKUs mapped to this category yet.</div>`;
    }
    items.forEach(p=>{
      const row = document.createElement('div');
      row.className = 'product-row';
      row.draggable = true;
      const thumbInner = p.thumb ? `<img src="${p.thumb}" alt="">` : p.name.split(' ').map(w=>w[0]).slice(0,2).join('');
      const pzNums = productZoneNumbers(currentEquip, p);
      const pzHtml = pzNums.map(n=>`<div class="pzone-num" style="background:${zoneColor(n)}" title="Drop on zone ${n}">${n}</div>`).join('');
      const pdesc = SBB_DESC[p.id] ? `<div class="pdesc">${SBB_DESC[p.id]}</div>` : '';
      row.innerHTML = `<div class="pthumb">${thumbInner}</div><div class="pinfo"><div class="pname">${p.name}</div>${pdesc}</div><div class="pzone-badges">${pzHtml}</div>`;
      row.addEventListener('dragstart', e=>{
        e.dataTransfer.setData('text/plain', p.id);
        row.classList.add('dragging');
        highlightCompatible(p);
      });
      row.addEventListener('dragend', ()=>{ row.classList.remove('dragging'); clearHighlights(); });
      row.addEventListener('click', ()=> placeProduct(p, null) );
      inner.appendChild(row);
    });

    body.appendChild(inner);
    div.appendChild(head);
    div.appendChild(body);
    catList.appendChild(div);
  });
}

function renderStage(){
  const stage = document.getElementById('sbb-stage');
  stage.innerHTML = `<img class="bg" src="${HERO_IMG[currentEquip]}" alt="">`;
  const emptyMsg = document.createElement('div');
  emptyMsg.className = 'empty-msg';
  emptyMsg.id = 'sbb-emptyMsg';
  emptyMsg.textContent = 'Drag a product from the right onto any highlighted zone to begin';
  stage.appendChild(emptyMsg);

  ZONES[currentEquip].forEach(z=>{
    const wrap = document.createElement('div');
    wrap.className = 'hotspot-wrap';
    wrap.style.left = z.x+'%';
    wrap.style.top = z.y+'%';

    const spot = document.createElement('div');
    spot.className = 'hotspot';
    spot.dataset.key = z.key;
    spot.style.background = zoneColor(z.n);
    spot.textContent = z.n;

    spot.addEventListener('dragover', e=>{ if(spot.classList.contains('compatible')) e.preventDefault(); });
    spot.addEventListener('drop', e=>{
      e.preventDefault();
      const id = e.dataTransfer.getData('text/plain');
      const p = PRODUCTS[currentEquip].find(pp=>pp.id===id);
      if(p) placeProduct(p, z.key);
    });

    wrap.appendChild(spot);
    stage.appendChild(wrap);
  });

  refreshPlacedVisuals();
}

function zoneMatches(zone, product){
  return zone.key === product.zone || zone.group === product.zone;
}
function eligibleHotspots(product){
  return ZONES[currentEquip].filter(z=>zoneMatches(z,product));
}
function highlightCompatible(product){
  eligibleHotspots(product).forEach(z=>{
    const el = document.querySelector(`.hotspot[data-key="${z.key}"]`);
    if(el) el.classList.add('compatible');
  });
}
function clearHighlights(){
  document.querySelectorAll('.hotspot.compatible').forEach(el=>el.classList.remove('compatible'));
}

/* Some single-side (Left/Right, not Both) products only have artwork
   composited for one physical armrest. Left/Right defaults to the first
   eligible hotspot (arm_l) on a plain click, which would otherwise leave
   the arm_r badge stranded over art that's actually baked for the right
   side. This map forces the correct default zone for those SKUs. */
const DEFAULT_ZONE = { 'WC-032': 'arm_r', 'WC-033': 'arm_r' };

/* Products whose artwork covers other zones' badge positions: while placed,
   those badges are hidden. BED-022 (Bed-Foot Support) spans the foot of the bed. */
const HIDE_BADGES_WHEN_PLACED = { 'BED-022': ['mid','hip'], 'BED-048': ['leg_l'],
  'BED-013': ['hip'], 'BED-014': ['hip'], 'BED-015': ['hip'],
  'BED-051': ['monitor'], 'BED-052': ['monitor'],
  // wheelchair trays sit on top of both armrests, covering them
  'WC-034': ['arm_l','arm_r'], 'WC-035': ['arm_l','arm_r'], 'WC-036': ['arm_l','arm_r'], 'WC-039': ['arm_l','arm_r'] };

function placeProduct(product, preferredKey){
  const hotspots = eligibleHotspots(product);
  if(hotspots.length===0) return;
  let target = preferredKey ? hotspots.find(z=>z.key===preferredKey) : null;
  if(!target && DEFAULT_ZONE[product.id]) target = hotspots.find(z=>z.key===DEFAULT_ZONE[product.id]);
  if(!target) target = hotspots.find(z=>!placed[currentEquip][slotKeyFor(currentEquip, z.key, product)]) || hotspots[0];
  if(!target) return;

  const slot = slotKeyFor(currentEquip, target.key, product);
  const wasOccupied = !!placed[currentEquip][slot];
  placed[currentEquip][slot] = product.id;
  loadShopProduct(product);

  if(product.side && product.side.includes('Both') && target.group){
    const mirror = ZONES[currentEquip].find(z=>z.group===target.group && z.key!==target.key);
    if(mirror) placed[currentEquip][mirror.key] = product.id;
  }

  if(currentEquip==='wheelchair' && target.key==='feet'){
    const ll = ZONES[currentEquip].find(z=>z.key==='leg_l');
    const lr = ZONES[currentEquip].find(z=>z.key==='leg_r');
    if(ll) placed[currentEquip]['leg_l'] = product.id;
    if(lr) placed[currentEquip]['leg_r'] = product.id;
  }

  clearHighlights();
  refreshPlacedVisuals();
  showToast(wasOccupied ? `Swapped in ${product.name}` : `${product.name} added`);
}

function removePlaced(key, equip){
  const eq = equip || currentEquip;
  const p = PRODUCTS[eq].find(pp=>pp.id===placed[eq][key]);
  const linkedKeys = ['feet','leg_l','leg_r'];
  const isLinkedTriad = eq==='wheelchair' && linkedKeys.includes(key)
    && placed[eq]['feet'] && placed[eq]['leg_l']===placed[eq]['feet']
    && placed[eq]['leg_r']===placed[eq]['feet'];
  if(isLinkedTriad){
    delete placed[eq]['feet'];
    delete placed[eq]['leg_l'];
    delete placed[eq]['leg_r'];
  } else {
    const zoneDef = ZONES[eq].find(z=>z.key===baseKey(key));
    const mirror = zoneDef && zoneDef.group ? ZONES[eq].find(z=>z.group===zoneDef.group && z.key!==key) : null;
    const isMirroredPair = mirror && placed[eq][mirror.key] && placed[eq][mirror.key]===placed[eq][key];
    delete placed[eq][key];
    if(isMirroredPair) delete placed[eq][mirror.key];
  }
  refreshPlacedVisuals();
  if(p) showToast(`${p.name} removed`);
}

function refreshPlacedVisuals(){
  document.querySelectorAll('.placed-card, .placed-photo-full, .hover-zone, .rear-callout').forEach(t=>t.remove());
  document.querySelectorAll('.hotspot').forEach(h=>{ h.classList.remove('filled'); h.style.visibility='visible'; });
  document.querySelectorAll('.legend-row').forEach(r=>r.classList.remove('filled'));

  // the mid-body badge (6) sits visually on top of hip-zone (7) products on the bed image; hide it while that zone is occupied
  if(currentEquip==='bed' && placed.bed['hip']){
    const midSpot = document.querySelector('.hotspot[data-key="mid"]');
    if(midSpot) midSpot.style.visibility = 'hidden';
  }

  // some products physically cover neighbouring zones on the photo; hide those badges while the product is placed
  Object.values(placed[currentEquip]).forEach(id=>{
    (HIDE_BADGES_WHEN_PLACED[id] || []).forEach(k=>{
      const s = document.querySelector(`.hotspot[data-key="${k}"]`);
      if(s) s.style.visibility = 'hidden';
    });
  });

  let count = 0;
  const seen = new Set();
  const stage = document.getElementById('sbb-stage');
  const buildRows = []; // for the itemized list under the photo

  const orderedEntries = Object.entries(placed[currentEquip])
    .sort((a,b) => layerIndex(currentEquip, a[0], a[1]) - layerIndex(currentEquip, b[0], b[1]));
  const removeBtnCount = {}; // several items can share one zone; spread their remove buttons out

  orderedEntries.forEach(([key,id])=>{
    const zKey = baseKey(key);
    const spot = document.querySelector(`.hotspot[data-key="${zKey}"]`);
    if(!spot) return;
    spot.classList.add('filled');
    const legendRow = document.getElementById('sbb-legend-'+zKey);
    if(legendRow) legendRow.classList.add('filled');

    const p = PRODUCTS[currentEquip].find(pp=>pp.id===id);
    if(!p) return;
    if(!seen.has(id)){ count++; seen.add(id); }

    const zoneDef = ZONES[currentEquip].find(z=>z.key===zKey);

    const legLinkedId = currentEquip==='wheelchair' ? placed[currentEquip]['feet'] : null;
    const isLegLinked = legLinkedId && (key==='leg_l'||key==='leg_r') && placed[currentEquip][key]===legLinkedId;
    if(isLegLinked){ spot.style.visibility = 'hidden'; return; } // covered by the foot support product's own image

    // mirrored bed-rail products (side includes 'Both') show one callout only, anchored on the right rail
    const isSecondaryRailSide = zoneDef && zoneDef.group==='rail' && key==='rail_l'
      && placed[currentEquip]['rail_r'] === placed[currentEquip][key];
    if(isSecondaryRailSide){ spot.style.visibility = 'hidden'; return; }

    buildRows.push({p, zoneDef, key});

    if(p.img){
      // full-canvas product photo, framed identically to the hero photo
      spot.style.visibility = 'hidden';
      const layer = document.createElement('div');
      layer.className = 'placed-photo-full';
      layer.innerHTML = `<img src="${p.img}" alt="${p.name}">`;
      stage.appendChild(layer);
    }

    // hover target: the X only shows when hovering this item's spot
    const hz = document.createElement('div');
    hz.className = 'hover-zone';
    const nth = removeBtnCount[zKey] = (removeBtnCount[zKey] || 0) + 1;
    hz.style.left = nth > 1 ? `calc(${zoneDef.x}% + ${(nth-1)*40}px)` : zoneDef.x + '%';
    hz.style.top = zoneDef.y + '%';
    const rm = document.createElement('div');
    rm.className = 'placed-remove';
    rm.title = `Remove ${p.name}`;
    rm.textContent = '✕';
    rm.addEventListener('click', (e)=>{ e.stopPropagation(); removePlaced(key); });
    hz.appendChild(rm);
    stage.appendChild(hz);

    if(!p.img && (zKey==='rear' || zoneDef.group==='rail')){
      spot.style.visibility = 'hidden';
      const host = stage.parentElement;             // .stage-panel (position:relative)
      const anchorX = stage.offsetLeft + stage.clientWidth * (zoneDef.x/100);
      const anchorY = stage.offsetTop + stage.clientHeight * (zoneDef.y/100);
      const card = document.createElement('div');
      card.className = 'rear-callout';
      card.style.left = (anchorX + 20) + 'px';
      card.style.top = (anchorY - stage.clientHeight*0.04 + (nth-1)*168) + 'px'; // stack a second callout under the first
      const calloutLabel = zKey==='rear' ? 'Attaches to rear' : 'Fits on bed rail';
      const imgInner = p.thumb ? `<img src="${p.thumb}" alt="${p.name}">` : p.name.split(' ').map(w=>w[0]).slice(0,2).join('');
      card.innerHTML = `<div class="callout-label">${calloutLabel}</div><div class="callout-img">${imgInner}</div><div class="callout-name">${p.name}</div>`;
      const rm2 = document.createElement('button');
      rm2.title = `Remove ${p.name}`;
      rm2.textContent = '✕';
      rm2.addEventListener('click', (e)=>{ e.stopPropagation(); e.preventDefault(); removePlaced(key); });
      card.appendChild(rm2);
      host.appendChild(card);
    } else if(!p.img){
      const wrap = spot.parentElement;
      const card = document.createElement('div');
      card.className = 'placed-card';
      const thumbInner = p.name.split(' ').map(w=>w[0]).slice(0,2).join('');
      card.innerHTML = `<div class="thumb">${thumbInner}</div><span class="pname">${p.name}</span>`;
      wrap.appendChild(card);
    }
  });

  document.getElementById('sbb-itemCount').textContent = count;
  document.getElementById('sbb-emptyMsg').style.display = count ? 'none' : 'block';
  renderBuildList(allBuildRows());
}

/* Your Build lists everything placed on BOTH the wheelchair and the bed,
   so switching tabs never loses anything. */
function buildRowsFor(eq){
  const rows = [], seen = new Set();
  Object.entries(placed[eq])
    .sort((a,b)=> (ZONES[eq].find(z=>z.key===baseKey(a[0]))||{n:99}).n - (ZONES[eq].find(z=>z.key===baseKey(b[0]))||{n:99}).n)
    .forEach(([key,id])=>{
      if(seen.has(id)) return;                        // "Both"-side / linked items list once
      const p = PRODUCTS[eq].find(pp=>pp.id===id); if(!p) return;
      const zoneDef = ZONES[eq].find(z=>z.key===baseKey(key)); if(!zoneDef) return;
      if(eq==='wheelchair' && (key==='leg_l'||key==='leg_r') && placed[eq]['feet']===id) return; // shown under Foot Support
      if(key==='rail_l' && placed[eq]['rail_r']===id) return;                                    // shown under the right rail
      seen.add(id); rows.push({p, zoneDef, key, equip:eq});
    });
  return rows;
}
function allBuildRows(){ return [...buildRowsFor('wheelchair'), ...buildRowsFor('bed')]; }
const EQUIP_LABEL = { wheelchair:'Wheelchair', bed:'Hospital Bed' };

let _lastBuildRows = [];
function renderBuildList(rows){
  _lastBuildRows = rows;
  const el = document.getElementById('sbb-buildList');
  if(rows.length===0){
    el.innerHTML = `<h4>Your Build</h4><div class="empty">Nothing added yet — drag a product onto the wheelchair or the bed to start.</div>`;
    return;
  }
  const seen = new Set();
  let html = `<h4>Your Build</h4>`;
  let total = 0, anyLoading = false, anyAddable = false, lastEquip = null;
  rows.forEach(({p, zoneDef, key, equip})=>{
    if(seen.has(p.id)) return; // "Both" side items occupy two zones but list once
    seen.add(p.id);
    if(equip!==lastEquip){ html += `<div class="build-group">${EQUIP_LABEL[equip]}</div>`; lastEquip = equip; }
    if(!shopData[p.id]) loadShopProduct(p);
    const rec = shopData[p.id];
    if(rec.status==='loading' && !rec._redraw){ rec._redraw = true; rec.promise.then(()=>renderBuildList(_lastBuildRows)); }
    const thumbInner = p.thumb ? `<img src="${p.thumb}" alt="" loading="lazy">` : p.name.split(' ').map(w=>w[0]).slice(0,2).join('');
    const qty = qtyFor(p);
    let variantHtml = '', priceHtml = '';
    if(rec.status==='loading'){ anyLoading = true; variantHtml = `<span class="bzone" style="flex:none;">Checking options…</span>`; }
    else if(rec.status==='missing'){ variantHtml = `<span class="bmiss">Not available online</span>`; }
    else {
      const v = chosenVariant(p);
      const vs = rec.variants;
      const hasChoice = vs.length > 1 || (vs[0] && vs[0].title !== 'Default Title');
      if(hasChoice){
        variantHtml = `<select class="variant-select" data-pid="${p.id}" aria-label="Choose an option for ${escHtml(p.name)}">${
          vs.map(x=>`<option value="${x.id}" ${String(x.id)===String(v.id)?'selected':''} ${x.available?'':'disabled'}>${escHtml(x.title)}${x.available?'':' — sold out'}</option>`).join('')}</select>`;
      }
      if(v && v.available){ anyAddable = true; total += v.price * qty; priceHtml = `<span class="bprice">${qty>1?qty+' × ':''}${formatMoney(v.price)}</span>`; }
      else { priceHtml = `<span class="bmiss">Sold out</span>`; }
    }
    html += `<div class="build-row">
      <div class="num" style="background:${zoneColor(zoneDef.n)}">${zoneDef.n}</div>
      <div class="bthumb">${thumbInner}</div>
      <div class="info"><a class="bname" href="${productUrl(p)}" target="_blank" rel="noopener">${escHtml(p.name)}</a><div class="bzone">${zoneDef.label}</div></div>
      ${variantHtml}
      ${priceHtml}
      <button class="remove-link" data-key="${key}" data-equip="${equip}">Remove</button>
    </div>`;
  });
  html += `<div class="build-cart-row">
    <div class="bnote">${anyLoading ? 'Checking sizes and prices…' : (anyAddable ? `Bundle total: <b>${formatMoney(total)}</b>` : 'These items can’t be ordered online right now.')}</div>
    <button class="cta-btn" id="sbb-addCartBtn" ${anyAddable && !anyLoading ? '' : 'disabled'}>Add This Bundle to Cart</button>
  </div>`;
  el.innerHTML = html;
  el.querySelectorAll('.remove-link').forEach(btn=>{
    btn.addEventListener('click', ()=> removePlaced(btn.dataset.key, btn.dataset.equip));
  });
  el.querySelectorAll('.variant-select').forEach(sel=>{
    sel.addEventListener('click', e=> e.stopPropagation());
    sel.addEventListener('change', ()=>{ selectedVariant[sel.dataset.pid] = sel.value; renderBuildList(_lastBuildRows); });
  });
  const cartBtn = document.getElementById('sbb-addCartBtn');
  if(cartBtn) cartBtn.addEventListener('click', onAddBundleToCart);
}

/* ---------------------------------------------------------------- CART (Shopify AJAX cart) */
async function onAddBundleToCart(){
  const rowsAll = allBuildRows();                       // everything in Your Build: wheelchair AND bed
  if(rowsAll.length===0){ showToast('Add products first'); return; }
  await Promise.all(rowsAll.map(r=>loadShopProduct(r.p)));
  const builder = [...new Set(rowsAll.map(r=>r.equip))].map(e=>EQUIP_LABEL[e]).join(' + ') + ' Builder';
  const items = [], skipped = [];
  rowsAll.forEach(({p, equip})=>{
    const v = chosenVariant(p);
    if(!v || !v.available){ skipped.push(p.name); return; }
    items.push({ id: v.id, quantity: qtyFor(p), properties: { '_Added from': 'Skil-Care ' + EQUIP_LABEL[equip] + ' Builder' } });
  });
  if(!items.length){ showToast('None of these items can be ordered online right now'); return; }
  const btn = document.getElementById('sbb-addCartBtn');
  if(btn){ btn.disabled = true; btn.textContent = 'Adding…'; }
  try{
    if(SBB.mock){
      await new Promise(r=>setTimeout(r,300));
      console.log('[preview] would POST /cart/add.js', JSON.stringify({items}));
    } else {
      const res = await fetch((SBB.root || '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
      });
      if(!res.ok){
        const err = await res.json().catch(()=>({}));
        throw new Error(err.description || err.message || 'Could not add the bundle to your cart');
      }
    }
    document.dispatchEvent(new CustomEvent('skilcare:bundle-added', { detail: { items, skipped, builder } }));
    const msg = `${items.length} item${items.length>1?'s':''} added to your cart` + (skipped.length ? ` (${skipped.length} unavailable)` : '');
    showToast(msg);
    if(!SBB.mock && SBB.afterAdd !== 'stay'){ setTimeout(()=>{ window.location.href = SBB.cartUrl || '/cart'; }, 700); }
  } catch(e){
    showToast(e.message);
  } finally {
    if(btn){ btn.disabled = false; btn.textContent = 'Add This Bundle to Cart'; }
  }
}

/* ---------------------------------------------------------------- MISC */
function showToast(msg){
  const t = document.getElementById('sbb-toast');
  t.textContent = msg;
  t.classList.add('show');
  clearTimeout(showToast._t);
  showToast._t = setTimeout(()=>t.classList.remove('show'), 2200);
}

document.getElementById('sbb-clearBtn').addEventListener('click', ()=>{
  placed[currentEquip] = {};
  refreshPlacedVisuals();
  showToast('Cleared — start over any time');
});

/* equipment switch cards: each product's own photo, its counts, and the state line */
function refreshEquipCards(){
  ['wheelchair','bed'].forEach(e=>{
    const ph = document.querySelector(`[data-photo="${e}"]`);
    if(ph && HERO_IMG[e]) ph.style.backgroundImage = `url("${HERO_IMG[e]}")`;
    const meta = document.querySelector(`[data-meta="${e}"]`);
    if(meta) meta.textContent = `${PRODUCTS[e].length} accessories for ${ZONES[e].length} zones`;
    const st = document.querySelector(`[data-state="${e}"]`);
    if(st) st.textContent = (e===currentEquip) ? 'Building now' : 'Switch to this';
  });
}
document.querySelectorAll('[data-equip]').forEach(btn=>{
  btn.addEventListener('click', ()=>{
    if(btn.dataset.equip===currentEquip) return;
    document.querySelectorAll('[data-equip]').forEach(b=>{ b.classList.remove('active'); b.setAttribute('aria-pressed','false'); });
    btn.classList.add('active'); btn.setAttribute('aria-pressed','true');
    currentEquip = btn.dataset.equip;
    document.getElementById('sbb-pageTitle').textContent = TITLES[currentEquip].title;
    document.getElementById('sbb-pageSub').textContent = TITLES[currentEquip].sub;
    document.getElementById('sbb-legendTitle').textContent = 'Drop Zones';
    renderLegend();
    renderDrawer();
    renderStage();
    refreshEquipCards();
  });
});

/* keep callouts anchored when the page is resized */
let _sbbResize; window.addEventListener('resize', ()=>{ clearTimeout(_sbbResize); _sbbResize = setTimeout(refreshPlacedVisuals, 150); });

/* init */
refreshEquipCards();
renderLegend();
renderDrawer();
renderStage();
if (SBB.startWith === 'bed') { const b = document.querySelector('.sbb-root [data-equip="bed"]'); if (b) b.click(); }

})();
